import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
// don't want to use this?
// have a look at the Quick start guide
// for passing in lng and translations on init

const Languages = ["en", "thai"];

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // backend: {
    //   // translation file path
    //   loadPath: "/locales/i18n/{{ns}}/{{lng}}.json",
    // },
    fallbackLng: "en",
    // disabled in production
    debug: false,
    whiteList: Languages,
    // can have multiple namespaces, in case you want to divide a huge

    interpolation: {
      espaceValue: false,
      formatSeparator: ",",
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
